import { routes } from "./routes";
import { Routes, Route, useNavigate } from 'react-router-dom'
import { Provider } from "react-redux";
import store from "./store";
import Middleware from "./middleware";
import Dashboard from "./modules/dashboard/containers/Dashboard";
import HeaderLogged from "./common/containers/HeaderLogged";

function App() {
  window.navigate = useNavigate()
  return (
    <Provider store={store}>
      <Routes>
        {routes.map((a, ai) => <Route path={a.path} key={ai} element={<Middleware forceAuth={a.forceAuth} header={null}><a.container /></Middleware>} />)}
        <Route path="/*" index element={<Middleware forceAuth={true} header={<HeaderLogged />}><Dashboard /></Middleware>} />
      </Routes>
    </Provider>
  );
}

export default App